interface Props {
    message: string;
    onDismiss: () => void;
}

export default function InlineErrorBanner({ message, onDismiss }: Props) {
    return (
        <div className='inline-error-banner'>
            {message}
            <button className='inline-error-dismiss' onClick={onDismiss}>×</button>
        </div>
    );
}